module.exports = __webpack_public_path__ + "img/voice-stop.a3d79744.png";